var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeofDuPageFoundation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7065 8.57959L31.0371 13.9116L17.7065 19.2097L7.75992 15.2449C7.14414 15.7579 6.70008 16.5782 6.63227 17.5013H6.8718C7.14523 17.5013 7.35086 17.7069 7.35086 17.9804V19.2447C7.35086 19.5182 7.14523 19.7238 6.8718 19.7238H6.70117L7.35086 26.3552C7.38477 26.6287 7.18023 26.8682 6.9068 26.8682H5.71023C5.4368 26.8682 5.23117 26.6287 5.23117 26.3552L5.91477 19.7238H5.74414C5.4707 19.7238 5.23117 19.5182 5.23117 19.2447V17.9804C5.23117 17.7069 5.4707 17.5013 5.74414 17.5013H6.12039C6.1893 16.5104 6.63336 15.6551 7.24805 15.0404L4.37695 13.9127L17.7065 8.57959ZM17.3302 20.1668L17.7065 20.3035L18.0827 20.1668L25.3977 17.2268L25.9446 23.2763C25.9785 23.6865 25.7051 23.8571 25.3288 23.6865L22.4577 22.2165C22.0815 22.0108 21.4668 22.0458 21.1245 22.2504L18.3562 23.8232C18.0138 24.0288 17.3991 24.0288 17.0568 23.8232L14.2885 22.2504C13.9462 22.0447 13.3315 22.0108 12.9891 22.2165L10.0841 23.6865C9.70789 23.8921 9.43445 23.6865 9.46836 23.2763L10.0152 17.2268L17.3302 20.1668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeofDuPageFoundation);
export default __webpack_public_path__ + "static/media/College of DuPage Foundation.4d113f2d56a6d2dfb96182df69d4ab37.svg";
export { ForwardRef as ReactComponent };